import { render, staticRenderFns } from "./data-collect-minimization-status.vue?vue&type=template&id=46d691c9&scoped=true"
import script from "./data-collect-minimization-status.vue?vue&type=script&lang=js"
export * from "./data-collect-minimization-status.vue?vue&type=script&lang=js"
import style0 from "./data-collect-minimization-status.vue?vue&type=style&index=0&id=46d691c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d691c9",
  null
  
)

export default component.exports